module.exports = __webpack_public_path__ + "media/images/dashboard/about_hero_desktop-b4930b8982d4010295fb2fbc80217764.jpg";